import { styled } from "sharedUI/styles";

export const InviteUserToAppModalStyle = styled.div`
    display: flex;
    flex-direction: column;

    color: ${p => p.theme.fgColorDark};

    padding: 20px 0;
    .header {
        font-size: 14px;
        color: ${p => p.theme.fgColorMedium};
        margin-bottom: 12px;
    }

    .cardWrapper {
        border: 1px solid ${p => p.theme.borderColor};
        padding: 4px 12px;
        height: 32px;
        border-radius: 8px;

        display: flex;
        flex-direction: column;
        justify-content: center;
    }

    .stripe {
        margin-top: 8px;
        align-self: flex-end;
    }

    .form-input {
        border: 1px solid ${p => p.theme.borderColor};
        padding: 4px 12px;
        height: 32px;
        border-radius: 8px;
        font-size: 14px;
        margin-bottom: 12px;
        color: ${p => p.theme.fgColorDark};
    }

    .city-zip-container {
        display: grid;
        grid-template-columns: minmax(0, 5fr) minmax(0, 2fr) minmax(0, 3fr);

        > *:not(:last-child) {
            margin-right: 8px;
        }
    }
`;
